import { useLayoutEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Deactivation } from '@elfsight/widget-deactivation';
import { useStorage } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { positions } from '../constants';
import { meta } from '../meta';
import { Button, CallWidget, Window } from './components';
import { devices, pages, time, visitors } from './helpers';

export function Widget() {
  const settings = useSettings();
  const { position: positionSetting, deactivate, editMode } = settings;
  const { position, align } = positions[positionSetting];
  const [show, toggleShow] = useState(false);
  const newUserTimeStorage = useStorage('newUserTime', undefined);

  useLayoutEffect(() => {
    const passesDisplayRules =
      pages(settings) &&
      time(settings) &&
      visitors(settings, newUserTimeStorage) &&
      devices(settings);
    const shouldShow = editMode || passesDisplayRules;

    toggleShow(shouldShow);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, newUserTimeStorage]);

  return (
    <Component _align={align} _position={position} _show={show}>
      <CallWidget>
        {({ showWindow, onClick }) => (
          <Container _align={align}>
            <Window show={showWindow} />
            <Button show={showWindow} onClick={onClick} />
          </Container>
        )}
      </CallWidget>

      <Deactivation appAlias={meta.alias} displayDeactivation={deactivate} />
    </Component>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ _align }) =>
    _align === 'left' ? 'flex-start' : 'flex-end'};
`;

const Component = styled.div`
  display: flex;
  transition: 0.3s ease all;
  position: ${({ _position }) =>
    _position === 'floating' ? 'fixed' : 'inherit'};
  opacity: ${({ _show }) => (_show ? '1' : '0')};
  transform: ${({ _show }) => (_show ? 'translateY(0)' : 'translateY(100%)')};
  z-index: ${({ _show }) => (_show ? '999999999' : '-1')};

  ${({ _align, _position }) =>
    _position !== 'embed' &&
    css`
      ${_align === 'left' ? 'left: 20px;' : 'right: 20px;'}
      bottom: 20px;
    `}
`;
